import React, { PropsWithChildren } from 'react'

/**
 * As whammy does not handle sensitive data, we'll unmask all of its components
 * For more information, please refer to:
 * https://help.fullstory.com/hc/en-us/articles/360044349073-Fullstory-Private-by-Default
 * @param param0
 * @returns A React component that unmasks its children for FullStory recording
 */
const FullStoryUnmask = ({ children }: PropsWithChildren): React.JSX.Element => (
  <div className="fs-unmask">{children}</div>
)

export { FullStoryUnmask }
